{
  "name": "group-classes",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "build:docker": "ng build -c=docker --output-hashing=bundles"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "20.3.18",
    "@angular/common": "20.3.18",
    "@angular/compiler": "20.3.18",
    "@angular/core": "20.3.18",
    "@angular/forms": "20.3.18",
    "@angular/platform-browser": "20.3.18",
    "@angular/platform-browser-dynamic": "20.3.18",
    "@angular/router": "20.3.18",
    "@angular/service-worker": "20.3.18",
    "@azure/msal-angular": "4.0.18",
    "@azure/msal-browser": "4.20.0",
    "@bayclubs/audit-log-viewer": "19.1.0",
    "@bayclubs/calendar": "15.1.0",
    "@bayclubs/drop-down": "12.0.0",
    "@bayclubs/employee-auth": "19.0.1",
    "@bayclubs/employee-management-api": "2.23.0",
    "@bayclubs/group-classes-employee-api": "1.11.0",
    "@bayclubs/horizon": "0.8.17",
    "@bayclubs/logging": "9.10.1",
    "@bayclubs/providers-api": "4.9.0",
    "@bayclubs/providers-frontend": "8.0.1",
    "@bayclubs/recurring": "12.0.0",
    "@bayclubs/schematics": "7.0.0",
    "@bayclubs/spinner": "12.0.0",
    "@bayclubs/state": "11.0.1",
    "@bayclubs/ui-core": "3.0.0",
    "@bayclubs/ui-date-picker": "7.4.0",
    "@bayclubs/ui-icons": "3.0.2",
    "@bayclubs/ui-styles": "3.0.1",
    "@bayclubs/ui-text-mask": "3.0.0",
    "@bayclubs/ui-time-picker": "3.1.0",
    "@bayclubs/utils": "12.1.0",
    "@grafana/faro-web-sdk": "^2.7.1",
    "@grafana/faro-web-tracing": "^2.7.1",
    "@ngx-translate/core": "17.0.0",
    "@ngx-translate/http-loader": "17.0.0",
    "@ngxs/devtools-plugin": "20.1.0",
    "@ngxs/form-plugin": "20.1.0",
    "@ngxs/router-plugin": "20.1.0",
    "@ngxs/storage-plugin": "20.1.0",
    "@ngxs/store": "20.1.0",
    "bootstrap": "4.5.2",
    "core-js": "3.6.5",
    "deepmerge-ts": "7.0.3",
    "guid-typescript": "1.0.9",
    "jquery": "3.5.1",
    "lodash": "4.17.21",
    "moment": "2.29.4",
    "moment-timezone": "0.5.32",
    "ng-click-outside": "7.0.0",
    "ngx-bootstrap": "20.0.0",
    "ngx-device-detector": "10.0.2",
    "ngx-drag-drop": "20.0.1",
    "ngx-mask": "20.0.3",
    "ngx-translate-multi-http-loader": "20.0.0",
    "ngx-ui-switch": "15.0.0",
    "ngxs-reset-plugin": "4.0.0",
    "popper.js": "1.16.1",
    "rxjs": "7.8.2",
    "save": "2.5.0",
    "stacktrace-js": "2.0.2",
    "text-mask-addons": "3.8.0",
    "tslib": "2.6.2",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "20.3.22",
    "@angular-devkit/core": "20.3.22",
    "@angular/cli": "20.3.22",
    "@angular/compiler-cli": "20.3.18",
    "@angular/language-service": "20.3.18",
    "@types/jasmine": "4.3.1",
    "@types/jasminewd2": "2.0.8",
    "@types/node": "14.11.2",
    "codelyzer": "^6.0.0",
    "jasmine-core": "~3.6.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "6.3.4",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage-istanbul-reporter": "3.0.3",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "protractor": "7.0.0",
    "ts-node": "9.0.0",
    "tslint": "6.1.3",
    "typescript": "5.8.3"
  }
}
